/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityLogoUrl
 */
export interface EntityLogoUrl {
}

/**
 * Check if a given object implements the EntityLogoUrl interface.
 */
export function instanceOfEntityLogoUrl(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityLogoUrlFromJSON(json: any): EntityLogoUrl {
    return EntityLogoUrlFromJSONTyped(json, false);
}

export function EntityLogoUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityLogoUrl {
    return json;
}

export function EntityLogoUrlToJSON(value?: EntityLogoUrl | null): any {
    return value;
}

